import React from 'react'
import { createUseClasses } from '../common'
import { Contact } from '../components/contact'
import { Html } from '../components/html'
import { Posts } from '../components/posts'
import { RichContent } from '../components/richContent'
import { Head } from '../layouts'
import { CONTENT, DETAIL } from '../styles'

// hooks

const useClasses = createUseClasses(CONTENT, DETAIL)

// components

const PageTemplate = ({ pageContext: page }) => {
  const classes = useClasses()

  return (
    <>
      <Head canonical={page.slug} title={page.title} />

      <div className={classes.detail}>
        <div className={classes.content}>
          {page.content.contentList.map(item => (
            <div key={item._key}>
              <RichContent richContent={item._rawRichContent} />

              {item.html === 'HOO_LOGIC_CONTACT_FORM' ? <Contact /> : item.html === 'HOO_LOGIC_BLOG_POSTS' ? <Posts /> : <Html html={item.html} />}
            </div>
          ))}
        </div>
      </div>
    </>
  )
}

export default PageTemplate
